import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { UntilDestroy } from '@ngneat/until-destroy';

import { HdmuiKeyValueComponent } from '@heidelberg/hdmui-angular';
import {
    AmountDialogFormData,
    OperationAmountDetails,
} from '@data-terminal/feature-workstation-details/models/amount-report-details.model';
import { DynamicNumberPipe } from '@data-terminal/utils/pipes/dynamic-number.pipe';

@UntilDestroy()
@Component({
    selector: 'data-terminal-amount-report-details',
    templateUrl: './amount-report-details.component.html',
    styleUrls: ['./amount-report-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AmountReportDetailsComponent {
    @Input() public formData!: AmountDialogFormData | null;
    @Input() public operationData!: OperationAmountDetails | null;
    @Input() public isFinishOperation = false;
    @Input() public isAmountsReportingAllowed?: boolean = false;
}

@NgModule({
    declarations: [AmountReportDetailsComponent],
    exports: [AmountReportDetailsComponent],
    imports: [CommonModule, TranslateModule, HdmuiKeyValueComponent, MatProgressBarModule, DynamicNumberPipe],
})
export class AmountReportDetailsModule {}
